import { Button, ButtonProps } from "@material-ui/core";
import React, { useCallback } from "react";
import { useNavigator } from "../AppHistory";

type CancelButtonProps = ButtonProps;

export const CancelButton: React.FC<CancelButtonProps> = ({
  onClick,
  children,
  ...props
}) => {
  const { closeOverlay } = useNavigator();

  const handleClick = useCallback(
    (e) => {
      if (typeof onClick === "function") {
        onClick(e);
      }

      closeOverlay();
    },
    [onClick, closeOverlay],
  );

  return (
    <Button
      data-testid="Button--cancel"
      onClick={handleClick}
      color="primary"
      size="large"
      {...props}
    >
      {children ? children : "Cancel"}
    </Button>
  );
};
